<template>
    <b-container fluid class="mt-3">
        <b-row>
            <b-col xl="4" lg="6" md="12">
                <b-card no-body>
                    <template #header class="text-center">
                        <h6 class="mb-0 text-center">Clients
                            <b-badge variant="primary" class="float-right" pill>{{ nbClients }}</b-badge>
                        </h6>
                    </template>

                    <b-list-group flush>
                        <b-list-group-item>
                            Client instances configured : {{nbClients}}
                        </b-list-group-item>
                    </b-list-group>

                    <b-card-body>
                        <b-link :to="{ name: 'Clients'}" class="card-link">Clients</b-link>
                    </b-card-body>
                </b-card>
            </b-col>
            <b-col xl="4" lg="6" md="12">
                <b-card no-body>
                    <template #header class="text-center">
                        <h6 class="mb-0 text-center">Portal
                            <b-badge variant="primary" class="float-right" pill>{{ nbPortals.total }}</b-badge>
                        </h6>
                    </template>

                    <b-table-simple responsive fixed>
                        <b-thead>
                            <b-tr class="text-center">
                                <b-th>
                                    <b-link :to="{ name: 'ConfPortals'}" class="card-link">Portals</b-link>
                                </b-th>
                                <b-th>
                                    <b-link :to="{ name: 'ConfMyPortals'}" class="card-link">My Portals</b-link>
                                </b-th>
                            </b-tr>
                        </b-thead>
                        <b-tbody>
                            <b-tr>
                                <b-td>
                                    <canvas id="portals-pie-chart"></canvas>
                                </b-td>
                                <b-td>
                                    <canvas id="myportals-pie-chart"></canvas>
                                </b-td>
                            </b-tr>
                        </b-tbody>
                    </b-table-simple>
                </b-card>
            </b-col>
            <b-col xl="4" lg="6" md="12">
                <b-card no-body>
                    <template #header class="text-center">
                        <h6 class="mb-0 text-center">Other</h6>
                    </template>

                    <b-list-group flush>
                        <b-list-group-item>
                            <b-link :to="{ name: 'ConfFiles'}" class="card-link">Files management</b-link>
                        </b-list-group-item>
                        <b-list-group-item>
                            <b-link :to="{ name: 'Monitoring'}" class="card-link">Monitoring</b-link>
                        </b-list-group-item>
                    </b-list-group>
                </b-card>
            </b-col>
        </b-row>
    </b-container>
</template>

<script>

import ClientDataService from "@/services/ClientDataService";
import PortalDataService from "@/services/PortalDataService";
import Chart from 'chart.js/auto'

export default {
    name: "Home.vue",
    data() {
        return {
            nbClients: null,
            nbPortals: {
                total: null,
                active: null,
                disabled: null,
                draft: null
            },
            nbMyPortals: {
                total: null,
                active: null,
                disabled: null,
                draft: null
            },
        }
    },
    computed: {
        currentUser() {
            return this.$store.state.auth.user;
        },
    },
    created() {
        document.title = "Portal : Configuration";
    },
    mounted() {
        this.init();
    },
    methods: {
        init() {
            this.countClients();
            this.countPortals();
            this.initPortals();
            this.initMyPortals();
        },
        countClients() {
            ClientDataService.countAll()
                .then(response => (this.nbClients = response.data))
                .catch(error => console.log(error))
        },
        countPortals() {
            PortalDataService.countAll()
                .then(response => (this.nbPortals.total = response.data))
                .catch(error => console.log(error))
        },
        initPortals() {
            // All portals
            const promiseActive = PortalDataService.count(false, true)
                .then(response => (this.nbPortals.active = response.data))
                .catch(error => console.log(error));

            const promiseDisabled = PortalDataService.count(true, true)
                .then(response => (this.nbPortals.disabled = response.data))
                .catch(error => console.log(error));

            const promiseDraft = PortalDataService.count(false, false)
                .then(response => (this.nbPortals.draft = response.data))
                .catch(error => console.log(error));

            Promise.all([promiseActive, promiseDisabled, promiseDraft]).then((values) => {
                const chartEl = document.getElementById("portals-pie-chart");
                const chart = Chart.getChart(chartEl);
                if (chart) {
                    chart.destroy();
                }
                new Chart(chartEl, {
                    type: 'pie',
                    data: {
                        labels: ["Active", "Disabled", "Draft"],
                        datasets: [{
                            label: "Portals",
                            backgroundColor: ["rgb(73, 165, 154)", "#6c757d", "rgb(218, 179, 70)"],
                            data: values
                        }]
                    }
                });
            });
        },
        initMyPortals() {
            // All portals
            const promiseActive = PortalDataService.countByManager(false, true, this.currentUser.email)
                .then(response => (this.nbMyPortals.active = response.data))
                .catch(error => console.log(error));

            const promiseDisabled = PortalDataService.countByManager(true, true, this.currentUser.email)
                .then(response => (this.nbMyPortals.disabled = response.data))
                .catch(error => console.log(error));

            const promiseDraft = PortalDataService.countByManager(false, false, this.currentUser.email)
                .then(response => (this.nbMyPortals.draft = response.data))
                .catch(error => console.log(error));

            Promise.all([promiseActive, promiseDisabled, promiseDraft]).then((values) => {
                const chartEl = document.getElementById("myportals-pie-chart");
                const chart = Chart.getChart(chartEl);
                if (chart) {
                    chart.destroy();
                }
                new Chart(chartEl, {
                    type: 'pie',
                    data: {
                        labels: ["Active", "Disabled", "Draft"],
                        datasets: [{
                            label: "Portals",
                            backgroundColor: ["rgb(73, 165, 154)", "#6c757d", "rgb(218, 179, 70)"],
                            data: values
                        }]
                    }
                });
            });
        }
    }
}
</script>

<style scoped>

</style>